export default function uniq(...arrays) {
  const map = {};
  const result = [];

  arrays.forEach(array => {
    array.forEach(id => {
      if (map[id]) {
        return;
      }

      map[id] = true;
      result.push(id);
    });
  });

  return result;
}



// WEBPACK FOOTER //
// ./~/virgo/src/utils/uniq.js